import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  dialogPaper: {
    transition: theme.transitions.create('max-width', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  dialogTitle: {
    backgroundColor: '#f5f5f5',
  },
  dialogTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  closeButton: {
    color: theme.palette.text.primary,
  },
  breadcrumbTitle: {
    color: theme.palette.text.primary,
  },
  breadcrumbSeparatorIcon: {
    color: 'inherit',
  },
  dialogActions: {
    display: 'flex',
    gap: 8,
    width: '100%',
    padding: '10px',
  },
  dialogActionsStep0: {
    justifyContent: 'flex-end',
  },
  dialogActionsOther: {
    justifyContent: 'space-between',
  },
  actionButton: {
    minWidth: 100,
  },
}));
